import React, { useEffect, useState } from 'react';
import { BrowserRouter,Routes,Route, useNavigate, useLocation, Navigate, Outlet } from 'react-router-dom';
import SignUpPage from './pages/auth/SignUpPage';
import VerifyAccount from './pages/auth/VerifyAccount';
import LoginPage from './pages/auth/LoginPage';
import Dashboard from './pages/dashboard/Dashboard';
import MainLayout from './pages/layouts/MainLayout';
import { useAppDispatch, useAppSelector } from './app/hooks';
import { getUserProfile, selectAuthentication, selectprofileLoadingStatus, unSetSessionExpiry } from './features/auth/authSlice';
import { APP_STATUS } from './helpers/constants';
import ErrorPage from './pages/layouts/Error';
import PaymentLinksPage from './pages/payment_links/PaymentLinksPage';
import CustomersPage from './pages/customers/CustomersPage';
import ResetPassword from './pages/auth/ResetPassword';
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer, toast } from 'react-toastify';
import { showToastMessage, unSetToast } from './features/generalSlice';
import NewPaymentLink from './pages/payment_links/NewPaymentLink';
import CollectionsPage from './pages/collections/CollectionsPage';
import SettlementsPage from './pages/settlements/SettlementsPage';
import ProfilePage from './pages/account_management/ProfilePage';
import BusinessDetailsPage from './pages/account_management/BusinessDetailsPage';
import TeamPage from './pages/account_management/TeamPage';
import ReportsPage from './pages/reports/ReportsPage';
import ApiKeysPage from './pages/developer/ApiKeysPage';
import WebHooksPage from './pages/developer/WebHooksPage';
import LinkCollectionsPage from './pages/payment_links/LinkCollectionsPage';
import DonationLinksPage from './pages/donation_links/DonationLinksPage';
import NewDonationLink from './pages/donation_links/NewDonationLink';

import NtumaDigitalLinksPage from './pages/ntuma_digital/NtumaDigitalLinksPage';
import NewNtumaDigitalItem from './pages/ntuma_digital/NewNtumaDigitalItem';

import EventsTicketLinksPage from "./pages/event_tickets/EventsTicketLinksPage";
import NewEventsTicketItem from "./pages/event_tickets/NewEventsTicketItem";


function App() {
  const reloadProfile = useAppSelector(state=>state.auth.reloadProfile)
  const dispatch = useAppDispatch();

  useEffect(()=>{
    // console.log(reloadProfile)
    if (reloadProfile) {
      dispatch(getUserProfile());
    }
  },[reloadProfile,dispatch])
  return (
    <div>
      <ToastComponent/>
      <BrowserRouter>
        <Routes>
            <Route index path='/'  element={<LoginPage/>} />  
            <Route  path='/reset-password'  element={<ResetPassword/>} />    
            <Route  path='/signup'  element={<SignUpPage/>} />   
            <Route  path='/verify-account'  element={<VerifyAccount/>} />  
            <Route element={ <ProtectedRoute><Outlet/></ProtectedRoute>}>{/* auth middleware */}
              <Route element={<MainLayout/>}>
                  <Route  path='/dashboard'  element={<Dashboard/>} />  
                  <Route  path='/payment-links'  element={<PaymentLinksPage/>} />  
                  <Route  path='/new-payment-link'  element={<NewPaymentLink/>} />  
                  <Route  path='/payment-links/edit/:ref'  element={<NewPaymentLink/>} />  

                  <Route  path='/donation-links'  element={<DonationLinksPage/>} />  
                  <Route  path='/new-donation-link'  element={<NewDonationLink/>} />  
                  <Route  path='/donation-links/edit/:ref'  element={<NewDonationLink/>} />  

                  <Route  path='/ntuma-digital-items'  element={<NtumaDigitalLinksPage/>} />  
                  <Route  path='/new-ntuma-digital-item'  element={<NewNtumaDigitalItem/>} />  
                  <Route  path='/ntuma-digital-items/edit/:ref'  element={<NewNtumaDigitalItem/>} />  


                  <Route path="/events-tickets" element={<EventsTicketLinksPage />} />
                  <Route path="/new-events-ticket-item" element={<NewEventsTicketItem />} />
                  <Route path="/events-tickets/edit/:ref" element={<NewEventsTicketItem />} />



                  <Route  path='/collections'  element={<CollectionsPage/>} />  
                  <Route  path='/customers'  element={<CustomersPage/>} />
                  <Route  path='/settlements'  element={<SettlementsPage/>} />
                  <Route  path='/profile'  element={<ProfilePage/>} />
                  <Route  path='/business-details'  element={<BusinessDetailsPage/>} />
                  <Route  path='/team'  element={<TeamPage/>} />
                  <Route  path='/reports'  element={<ReportsPage/>} />
                  <Route  path='/api-keys'  element={<ApiKeysPage/>} />
                  <Route  path='/webhooks'  element={<WebHooksPage/>} />
              </Route> 
              <Route  path='/live/:ref'  element={<LinkCollectionsPage/>} />  
            </Route>
            <Route path='*' element={<ErrorPage />} />
        </Routes>
      </BrowserRouter>
    </div>
   
  );
}

interface ProtectedRouteProps {
  children: React.ReactElement;
}

const ProtectedRoute = ({ children }:ProtectedRouteProps):React.ReactElement => {
  const profileLoadingStatus = useAppSelector(selectprofileLoadingStatus);
  const authenticated = useAppSelector(selectAuthentication)
  const dispatch = useAppDispatch();
  const location = useLocation()

  const navigate = useNavigate()
  const userSessionExpired = useAppSelector(state=>state.auth.userSessionExpired)
  
  useEffect(()=>{
    if (userSessionExpired ===true) {
      dispatch(showToastMessage({
        message:"Session Expired. Login to continue",
        type:"error",
        position: toast.POSITION.TOP_CENTER
      }));
      dispatch(unSetSessionExpiry())
      navigate("/")
    }
  },[userSessionExpired])

  useEffect(() => {
    console.log("555555555555")
    dispatch(getUserProfile());
  }, []);

  if (authenticated ==false) {
    return <Navigate to="/" state={{ path:location.pathname }} />
  }
  return profileLoadingStatus === APP_STATUS.PENDING ? (
    loadingComponent()
  ) : (
    children
  );
};


const loadingComponent = ()=>{
  return(
    <div className=' flex justify-center pt-14'>
        <div role="status">
          <svg aria-hidden="true" className="w-8 h-8 mr-2 text-gray-200 animate-spin  fill-gray-700" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor"/>
              <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill"/>
          </svg>
          <span className="sr-only">Loading...</span>
      </div>
    </div>
  );
}

const ToastComponent =()=>{
  const showToast = useAppSelector(state=> state.general.showToast)
  const toastData = useAppSelector(state=> state.general.toastData)
  const dispatch = useAppDispatch()


  useEffect(()=>{
    console.log("1a")
    if (showToast) {
      if (toastData.type == "error") {
        toast.error(toastData.message, {
            position: toastData.position,
        });
      }else if(toastData.type == "success"){
        toast.success(toastData.message, {
            position: toastData.position
        });
      }
      dispatch(unSetToast(true));
    }
  },[showToast])
  return (
    <div>
            <ToastContainer />
    </div>
  );
}

export default App;


